import axios from 'axios';
import { getAuthToken } from '../Redux/Service/FetchBaseQuery';
import { API_URL } from '../Config';
import store from '../Redux/index';
import { logout } from '../Redux/Reducers/Auth/AuthSilice';

const api = axios.create({
   baseURL: API_URL,
});

// NEW: attach the token fresh on every outgoing request
api.interceptors.request.use(
   (config) => {
      console.log('opopooppoo');
      const token = getAuthToken();

      if (token) {
         config.headers.Authorization = `Bearer ${token}`;
         config.headers.token = token;
      } else {
         delete config.headers.Authorization;
         delete config.headers.token;
      }
      return config;
   },
   (error) => Promise.reject(error),
);

api.interceptors.response.use(
   (response) => response,
   (error) => {
      const status = error?.response?.status;

      if (status === 401) {
         store.dispatch(logout());
         localStorage.clear();
         window.location.replace('/login');
      }

      return Promise.reject(error);
   },
);

export default api;
